import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';

interface PresenceDotProps {
  userId: string;
  size?: number;
  borderWidth?: number;
  className?: string;
}

export function PresenceDot({ userId, size = 8, borderWidth = 1.5, className = '' }: PresenceDotProps) {
  const [isOnline, setIsOnline] = useState(false);

  useEffect(() => {
    if (!userId) return;

    // Controlla presenza tramite canale Supabase Presence
    const channel = supabase.channel('online-users');

    channel
      .on('presence', { event: 'sync' }, () => {
        const state = channel.presenceState();
        const online = Object.values(state).flat().some(
          (p: any) => p.user_id === userId
        );
        setIsOnline(online);
      })
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [userId]);

  if (!isOnline) return null;

  return (
    <span
      className={className}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: '#34D399',
        border: `${borderWidth}px solid white`,
        position: 'absolute',
      }}
    />
  );
}
